<template src="./OfflinePassenger.html">
</template>
<script>
import { getRoutes, getAvailableSeats } from '@/services/routes'
import { postOfflinePassenger } from '@/services/passenger'
import { format } from 'date-fns'

const initModel = {
  full_name: '',
  tel_no: '',
  dep_date: Date.now(),
  route: null,
  route_section: null,
  ref: 'OFFL',
  gender: 'M',
  seat_nos: '7',
  is_offline: true,
  others: [],
  email: 'payment@railroad.ng',
  amount_paid: 0
}

export default {
  name: 'OfflinePassenger',

  data () {
    return {
      ticketRef: '',
      isLoading: true,
      locationRoutes: [],
      loadedSeats: false,
      noOfAdults: 1,
      availableSeats: {},
      dialogVisible: false,
      passengerModel: Object.assign({}, initModel)
    }
  },

  mounted () {
    this.loadRoutes()
  },

  watch: {
    noOfAdults (newVal) {
      this.calculateFare()
    },

    'passengerModel.route' (newVal) {
      this.calculateFare()
    }
  },

  methods: {

    validateInput () {
      const seats = this.passengerModel.seat_nos.split(',').length
      if (this.noOfAdults !== seats) {
        this.$message.error('Seats does not tally with passengers')
        return false
      }

      if (this.passengerModel.dep_date === null) {
        this.$message.error('Please select a departure date')
        return false
      }

      if (this.passengerModel.route === null) { this.$message.error('Please select a travel route') }

      return true
    },

    calculateFare () {
      // TODO use the offline route amount for the calculation
      const routeId = this.passengerModel.route
      const route = this.locationRoutes.find(r => r.id === routeId)
      if (!route) {
        return
      }
      this.passengerModel.amount_paid = route.offline_amount * this.noOfAdults
    },

    onHandleConfirmDialog () {
      // verify that the select Route Car section has the selected seats
      const seats = this.passengerModel.seat_nos.split(',')
      // first check that selected seat is available in the selected car
      const selectedCarSeats = this.availableSeats[this.passengerModel.route_section]
      const validations = seats.filter(s => !selectedCarSeats.includes(parseInt(s)))

      if (seats.length !== this.noOfAdults) {
        this.$message.error('Total seat not equal to passengers')
        return
      }

      if (validations.length > 0) {
        // check if seat 7 is in the list of selected seats
        if (!validations.includes('7') || validations.length > 1) {
          this.$message.error(`Selected seats ${validations} is not in car`)
          return
        }
        this.dialogVisible = false
      }

      this.dialogVisible = false
    },

    onSaveOfflinePayment () {
      if (!this.validateInput()) {
        return
      }
      this.isLoading = true
      this.passengerModel['dep_date'] = format(this.passengerModel.dep_date, 'YYYY-MM-DD')
      const sectionDes = this.passengerModel.route_section
      this.passengerModel.route_section = this._parseRouteSectionCar(this.passengerModel.route, sectionDes)
      postOfflinePassenger(this.passengerModel)
        .then(res => {
          this.isLoading = false
          this.$message({
            message: 'Offline Passenger Created',
            type: 'success'
          })
          this.passengerModel = Object.assign({}, initModel)
          this.$router.push({ name: 'PrintPage', query: { ref: res.data.ref } })
        })
        .catch(() => {
          this.isLoading = false
          this.$message.error('Error creating offline passenger.\nTry again')
        })
    },

    _parseRouteSectionCar (route, sectionDescription) {
      const pRoute = this.locationRoutes.find(f => f.id === route)
      const key = 0
      if (pRoute && pRoute.sections) {
        const s = pRoute.sections.find(r => r.section === sectionDescription)
        if (s) {
          return s.key
        }
      }
      return key + 1 // for array indexing
    },

    onGetBookedSeats () {
      const routeId = this.passengerModel.route
      const depDate = format(this.passengerModel.dep_date, 'YYYY-MM-DD')
      getAvailableSeats(routeId, depDate)
        .then(res => {
          this.loadedSeats = true
          this.isLoading = false
          this.availableSeats = res.data
          this.dialogVisible = true
        })
        .catch(() => {
          this.loadedSeats = true
          this.isLoading = false
          this.dialogVisible = false
          this.$notify.error(
            'Error getting booked seats. Contact Developer'
          )
        })
    },

    loadRoutes () {
      getRoutes()
        .then(res => {
          this.locationRoutes = res.data.filter(r => r.active)
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss">
  .rr__route__select {
    display: inline-flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/passengers/create/OfflinePassenger.vue